import BadgeIcon, { type BadgeVariant } from "@/components/BadgeIcon"
import { Button } from "@/components/chadcn/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/chadcn/Dialog"
import Spinner from "@/components/Spinner"
import ContactSupportLink from "./ContactSupportLink"

export type LinkDeviceModalAction = {
  label: string
  onClick: () => void
  secondary?: boolean
  isLoading?: boolean
}

export type LinkDeviceModalProps = {
  open: boolean
  variant: BadgeVariant
  title: string
  description: string
  actions: [LinkDeviceModalAction] | [LinkDeviceModalAction, LinkDeviceModalAction]
  showHelpFooter?: boolean
}

const LinkDeviceModal = ({
  open,
  variant,
  title,
  description,
  actions,
  showHelpFooter = false,
}: LinkDeviceModalProps) => (
  <Dialog open={open}>
    <DialogContent className="w-[calc(100%-2rem)] max-w-sm gap-0 overflow-visible rounded-xl border-0 p-6 pt-16 sm:rounded-xl [&>button.absolute]:hidden">
      <BadgeIcon variant={variant} className="absolute -top-8 left-1/2 -translate-x-1/2" />
      <DialogHeader>
        <DialogTitle className="text-center text-h2 font-bold">{title}</DialogTitle>
        <DialogDescription className="pt-16 text-center text-base text-primary-contrast">
          {description}
        </DialogDescription>
      </DialogHeader>
      <div className="flex flex-col gap-3 pt-16">
        {actions.map(({ label, onClick, secondary, isLoading }) => (
          <Button
            key={label}
            type="button"
            variant={secondary ? "outline" : "default"}
            className="flex w-full gap-3 py-2 text-base"
            disabled={isLoading}
            onClick={onClick}
          >
            {isLoading && <Spinner />}
            {label}
          </Button>
        ))}
      </div>
      {showHelpFooter && (
        <div className="pt-6">
          <ContactSupportLink />
        </div>
      )}
    </DialogContent>
  </Dialog>
)

export default LinkDeviceModal
